const formatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  year: 'numeric',
});

/**
 * Formats a date as "MMMM YYYY" (e.g. "May 2026").
 *
 * Accepts a `YYYY-MM-DD` string (parsed in local time to avoid month-boundary
 * shifts across timezones) or a `Date`.
 */
export const formatMMMMYYYYLocal = (date: Date | string): string => {
  if (typeof date === 'string') {
    const [year, month, day] = date.split('-').map(Number);
    return formatter.format(new Date(year, month - 1, day || 1));
  }
  return formatter.format(date);
};
